var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":"Show concise/all data"}},[_c('v-checkbox',{staticClass:"ma-0",attrs:{"type":"checkbox","label":"Concise","hide-details":"","hint":"Show concise/all data"},on:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.concise),callback:function ($$v) {_vm.concise=$$v},expression:"concise"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }